export default __webpack_public_path__ + "static/media/Instagram.10936f20.svg";